<template>
	<div v-loading="loading">
		<h3>{{$t('app.register.name')}}</h3>
		<el-form @keyup.enter.native="submitForm('ruleForm')" :model="registerObj" :rules="formRules" ref="ruleForm">
			<el-form-item prop="username"><el-input v-model="registerObj.username" :placeholder="$t('app.account.username.placeholder')"></el-input></el-form-item>
			<el-form-item prop="password"><el-input v-model="registerObj.password" :placeholder="$t('app.account.password.placeholder')" show-password></el-input></el-form-item>
			<el-form-item prop="passwordAgain"><el-input v-model="registerObj.passwordAgain" :placeholder="$t('app.account.password.confirm_placeholder')" show-password></el-input></el-form-item>
			<el-form-item :label="$t('app.register.referral_code.name')" prop="code" v-if="registerObj.invitationCode">
				<el-input disabled  v-model="registerObj.invitationCode" :placeholder="$t('app.register.referral_code.placeholder')"></el-input>
			</el-form-item>
		</el-form>
		<div class="login-btn">
			<el-button @click="submitForm('ruleForm')" type="primary" style="width: 100%;">{{$t('app.register.button')}}</el-button>
			<br />
			<br />
			<el-button @click="$router.push('/login')" style="width: 100%;">{{$t('app.login.button')}}</el-button>
		</div>
	</div>
</template>

<script>
import { api_register_public } from '@/components/api/sign.js'
import { setToken } from "@/components/common/utils/tokenAuth";

export default {
	name: 'registerSub',
	inject: ['F_alertMsg', 'F_windowLoading', 'F_getErrMSg','F_reload','F_LOGIN'],
	data() {
		let validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('app.account.password.validator.confirm_required')))
			} else if (value !== this.$data.registerObj.password) {
				callback(new Error(this.$t('app.account.password.validator.confirm')))
			} else {
				callback()
			}
		}
		return {
			loading : false,
			registerObj: {
				username: '',
				password: '',
				passwordAgain: '',
				invitationCode: localStorage.getItem('referrer')
			},
			formRules: {
				username: [{ required: true, message: this.$t('app.account.username.validator.error'), trigger: 'blur' }],
				password: [{ required: true, message: this.$t('app.account.password.validator.error'), trigger: 'blur' }],
				passwordAgain: [{ validator: validatePass2 , required: true, trigger: 'blur' }],
				// code: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
			}
		}
	},
	created() {},
	methods: {
		 submitForm : function(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$options.methods.register(this)
				}
			});
		},
		register :function(this_){
			this_ = this_ || this
			if (this_.$data.loading){
				return
			}
			let username = this_.$data.registerObj.username
			let password = this_.$data.registerObj.password
			let invitationCode = this_.$data.registerObj.invitationCode
			this_.$data.loading = true
			api_register_public(username,password,invitationCode).then(res => {
				setToken(res.data,true)
				this_.F_LOGIN()
				this_.$router.push('/')
				this_.$data.loading = false
				// 清除邀请码
				localStorage.removeItem('referrer')
				this_.F_alertMsg(this_.$t('app.register.alert.success.title'),2)
			}).catch(err => {
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err,this_.$t('app.register.alert.error.title')),4)
			})
		}
	}
}
</script>

<style scoped>
.login-btn {
	margin-top: 70px;
}
</style>
